import script from "./Avatar.vue?vue&type=script&lang=ts&setup=true"
export * from "./Avatar.vue?vue&type=script&lang=ts&setup=true"

import "./Avatar.vue?vue&type=style&index=0&id=60b30617&lang=less"

const __exports__ = script;

export default __exports__